"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

/**
Form provides a convenient wrapper around the `<form>` tag,
which is generally what one uses when constructing a form.
**/
function Form(_ref) {
  var children = _ref.children,
      className = _ref.className,
      onSubmit = _ref.onSubmit,
      attrs = (0, _objectWithoutProperties2["default"])(_ref, ["children", "className", "onSubmit"]);
  var classes = (0, _classnames["default"])('zsg-form', className);
  return _react["default"].createElement("form", (0, _extends2["default"])({}, attrs, {
    className: classes,
    onSubmit: onSubmit
  }), children);
}

Form.displayName = 'Form';
Form.defaultProps = {
  onSubmit: function onSubmit(e) {
    e.stopPropagation();
    e.preventDefault();
  }
};
Form.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
  React elements.
  **/
  children: _propTypes["default"].node,

  /**
  Additional class names to add to the underlying `<form>`.
  **/
  className: _propTypes["default"].string,

  /**
  The callback fired when the underlying `<form>` submits.
  <br>It receives the event object as its only argument.
  **/
  onSubmit: _propTypes["default"].func
} : {};
var _default = Form;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@zillow/react-zsg/Form/Form.js
// module id = 481
// module chunks = 0